/* -----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The setting registry token.
 */
export const ISettingRegistry = new Token('@jupyterlab/coreutils:ISettingRegistry');
//# sourceMappingURL=tokens.js.map